import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.includes.js";
/** Convert Blob to base64 string */
export function blobToBase64(blob) {
  return new Promise((resolve, reject) => {
    var reader = new FileReader();
    reader.onloadend = () => {
      var result = reader.result;
      var base64 = result.includes(',') ? result.split(',')[1] : result;
      resolve(base64);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

/**
 * Convert Blob to ArrayBuffer.
 *
 * Notes:
 * - Use FileReader for legacy browser support (e.g. Chrome 49).
 */
export function blobToArrayBuffer(blob) {
  return new Promise((resolve, reject) => {
    var reader = new FileReader();
    reader.onloadend = () => {
      resolve(reader.result);
    };
    reader.onerror = reject;
    reader.readAsArrayBuffer(blob);
  });
}